import ShiftLocationSelector from "./ShiftLocationSelector";

export default ShiftLocationSelector;
